(function () {
  var timers = [];

  function parseDate(value) {
    var date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  function sortCards(container, cards) {
    var sorted = Array.prototype.slice.call(cards).sort(function(a, b) {
      var aDate = parseDate(a.dataset.entriesOpen);
      var bDate = parseDate(b.dataset.entriesOpen);
      var aTime = aDate ? aDate.getTime() : Number.MAX_SAFE_INTEGER;
      var bTime = bDate ? bDate.getTime() : Number.MAX_SAFE_INTEGER;
      if (aTime !== bTime) return aTime - bTime;
      return Number(a.dataset.originalIndex || 0) - Number(b.dataset.originalIndex || 0);
    });
    sorted.forEach(function(card) { container.appendChild(card); });
    return sorted;
  }

  function getCardState(card, now) {
    var open = parseDate(card.dataset.entriesOpen);
    var close = parseDate(card.dataset.entriesClose);
    if (!open || !close) return 'unavailable';
    if (now < open) return 'unavailable';
    if (now < close) return 'open';
    return 'closed';
  }

  function pickDefaultOpenCard(cards) {
    var now = new Date();
    var openCard = null;
    var upcomingCard = null;
    var latestClosedCard = null;
    var latestClosedTime = -Infinity;

    cards.forEach(function(card) {
      var open = parseDate(card.dataset.entriesOpen);
      var close = parseDate(card.dataset.entriesClose);
      var state = getCardState(card, now);
      if (state === 'open' && !openCard) openCard = card;
      if (state === 'unavailable' && open && open > now && !upcomingCard) upcomingCard = card;
      if (state === 'closed' && close && close.getTime() > latestClosedTime) {
        latestClosedTime = close.getTime();
        latestClosedCard = card;
      }
    });

    return openCard || upcomingCard || latestClosedCard || cards[0] || null;
  }

  function setCollapsed(card, collapsed) {
    var toggle = card.querySelector('[data-toggle]');
    card.setAttribute('data-collapsed', collapsed ? 'true' : 'false');
    if (toggle) toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  }

  function initRodeoRegistration(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('.dh-reg');
    if (!sections.length && scope.matches && scope.matches('.dh-reg')) sections = [scope];
    if (!sections.length) sections = [document];

    sections.forEach(function(section) {
      var list = section.querySelector ? section.querySelector('.dh-rodeos') : null;
      if (!list) return;

      var cards = list.querySelectorAll('[data-rodeo]');
      if (!cards.length) return;

      var shouldSort = String(section.dataset.autoSort || 'true') === 'true';
      var shouldAutoExpand = String(section.dataset.autoExpand || 'true') === 'true';
      var orderedCards = shouldSort ? sortCards(list, cards) : Array.prototype.slice.call(cards);

      if (shouldAutoExpand && section.dataset.dhAutoExpanded !== 'true') {
        var defaultOpen = pickDefaultOpenCard(orderedCards);
        orderedCards.forEach(function(card) { setCollapsed(card, card !== defaultOpen); });
        section.dataset.dhAutoExpanded = 'true';
      }

      orderedCards.forEach(function(card) {
        if (card.dataset.dhInitialized === 'true') return;
        card.dataset.dhInitialized = 'true';

        var toggle = card.querySelector('[data-toggle]');
        if (toggle) {
          toggle.addEventListener('click', function() {
            var collapsed = card.getAttribute('data-collapsed') === 'true';
            setCollapsed(card, !collapsed);
          });
        }

        var open = parseDate(card.dataset.entriesOpen);
        var close = parseDate(card.dataset.entriesClose);
        var timezoneLabel = card.dataset.timezoneLabel || 'MST';
        var registerUrl = card.dataset.registerUrl || '#';
        var registerMode = card.dataset.registerMode || 'link';
        var jotformUrl = card.dataset.jotformUrl || registerUrl;
        var btn = card.querySelector('[data-register]');
        var pill = card.querySelector('[data-status]');
        var label = pill ? pill.querySelector('.dh-status__label') : null;
        var grid = card.querySelector('[data-countdown]');
        var cdHeading = card.querySelector('[data-cd-heading]');
        var cdSub = card.querySelector('[data-cd-sub]');
        var note = card.querySelector('[data-cta-note]');
        var embed = card.querySelector('[data-jotform-embed]');

        if (btn && registerUrl) btn.setAttribute('href', registerUrl);

        if (btn) {
          btn.addEventListener('click', function(event) {
            if (btn.getAttribute('aria-disabled') === 'true') {
              event.preventDefault();
              return;
            }

            if (registerMode === 'popup' && jotformUrl) {
              event.preventDefault();
              openModal(jotformUrl);
            }

            if (registerMode === 'embed' && embed) {
              event.preventDefault();
              embed.hidden = !embed.hidden;
              if (!embed.hidden) embed.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
        }

        function fmt(n) { return n < 10 ? '0' + n : String(n); }

        function fmtDT(d) {
          if (!d) return '';
          return d.toLocaleString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            timeZone: 'America/Denver'
          }) + ' ' + timezoneLabel;
        }

        function setButtonDisabled(disabled) {
          if (!btn) return;
          if (disabled) {
            btn.setAttribute('aria-disabled', 'true');
            btn.setAttribute('tabindex', '-1');
          } else {
            btn.removeAttribute('aria-disabled');
            btn.removeAttribute('tabindex');
          }
        }

        function setStatus(state) {
          if (pill) {
            pill.classList.toggle('dh-status--open', state === 'open');
            pill.classList.toggle('dh-status--closed', state === 'closed');
          }

          if (state === 'open') {
            if (label) label.innerHTML = 'Entries · <b>Open Now</b>';
            setButtonDisabled(false);
            if (cdHeading) cdHeading.textContent = 'Time Until Entries Close';
            if (cdSub) cdSub.textContent = 'Closes ' + fmtDT(close);
            if (note) note.innerHTML = 'Entries are <b>open</b>. Closes <b>' + fmtDT(close) + '</b>.';
            if (grid) grid.style.opacity = '';
          } else if (state === 'closed') {
            if (label) label.innerHTML = 'Entries · <b>Closed</b>';
            setButtonDisabled(true);
            if (cdHeading) cdHeading.textContent = 'Entries Are Closed';
            if (cdSub) cdSub.textContent = 'See you at the rodeo.';
            if (note) note.innerHTML = 'Entries have <b>closed</b>. See you at the performance.';
            if (grid) grid.style.opacity = '.45';
            if (embed) embed.hidden = true;
          } else {
            if (label) label.innerHTML = 'Entries · <b>Unavailable</b>';
            setButtonDisabled(true);
            if (cdHeading) cdHeading.textContent = 'Time Until Entries Open';
            if (cdSub) cdSub.textContent = open ? 'Opens ' + fmtDT(open) : 'Entry window coming soon.';
            if (note) note.innerHTML = open ? 'Registration is currently <b>unavailable</b>. Button activates automatically when entries open on <b>' + fmtDT(open) + '</b>.' : 'Registration is currently <b>unavailable</b>. Check back for entry dates.';
            if (grid) grid.style.opacity = '';
            if (embed) embed.hidden = true;
          }
        }

        function writeCountdown(target) {
          if (!grid) return;
          var d = grid.querySelector('[data-cd="d"]');
          var h = grid.querySelector('[data-cd="h"]');
          var m = grid.querySelector('[data-cd="m"]');
          var s = grid.querySelector('[data-cd="s"]');

          if (!target) {
            if (d) d.textContent = '--';
            if (h) h.textContent = '--';
            if (m) m.textContent = '--';
            if (s) s.textContent = '--';
            return;
          }

          var diff = Math.max(0, target - new Date());
          if (d) d.textContent = fmt(Math.floor(diff / 86400000));
          if (h) h.textContent = fmt(Math.floor(diff / 3600000) % 24);
          if (m) m.textContent = fmt(Math.floor(diff / 60000) % 60);
          if (s) s.textContent = fmt(Math.floor(diff / 1000) % 60);
        }

        function tick() {
          var now = new Date();
          var target = null;
          var state = 'closed';

          if (!open || !close) {
            state = 'unavailable';
          } else if (now < open) {
            target = open;
            state = 'unavailable';
          } else if (now < close) {
            target = close;
            state = 'open';
          }

          setStatus(state);
          writeCountdown(target);
        }

        tick();
        timers.push(window.setInterval(tick, 1000));
      });
    });
  }

  function openModal(url) {
    var modal = document.querySelector('[data-dh-modal]');
    var iframe = document.querySelector('[data-dh-modal-iframe]');
    if (!modal || !iframe) return;
    iframe.src = url;
    modal.hidden = false;
    document.body.classList.add('dh-modal-open');
  }

  function closeModal() {
    var modal = document.querySelector('[data-dh-modal]');
    var iframe = document.querySelector('[data-dh-modal-iframe]');
    if (!modal || !iframe) return;
    modal.hidden = true;
    iframe.src = '';
    document.body.classList.remove('dh-modal-open');
  }

  document.addEventListener('click', function(event) {
    if (event.target.matches('[data-dh-modal-close]')) closeModal();
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') closeModal();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initRodeoRegistration(document); });
  } else {
    initRodeoRegistration(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initRodeoRegistration(event.target);
  });

  document.addEventListener('shopify:section:unload', function() {
    timers.forEach(function(timer) { window.clearInterval(timer); });
    timers = [];
  });
})();
